<template>
  <div v-if="isSavingCharges" class="status-msg my-md">
    <span>
      <img :src="Payments" width="240" height="175" alt=""/>
      <p class="mt-m40">Saving Your Changes!</p>
    </span>
  </div>
  <div v-else class="tab-content pb-0">
    <Row class="grid-header header-plain header-collapse px-0 pt-0">
      <Col :span="columnSpan">
        <div class="cell">{{ $t('CHARGE_TYPE') }}</div>
      </Col>
      <Col v-if="!hideSystemCharges" :span="isShipperChargesFeatureEnabled ? 5 : 5">
        <div class="cell text-right">{{ $t('SYSTEM_CHARGE') }}</div>
      </Col>
      <Col :span="isShipperChargesFeatureEnabled ? 5 : 5">
        <div class="cell text-right">{{ $t('TRANSPORTER_CHARGE') }}</div>
      </Col>
      <Col v-if="isShipperChargesFeatureEnabled" :span="4">
        <div class="cell text-right">{{ $t('SHIPPER_CHARGES') }}</div>
      </Col>
    </Row>
    <div :class="{ 'scroll-inner': chargesFixedHeight }"
    :style="chargesFixedHeight ? 'max-height:340px;' : ''">
      <Collapse
        v-model="activeName"
        accordion
        disable="arrow"
        highlight="true"
        class="collapse-table bordered"
      >
        <CollapseItem
          :name="index"
          v-for="(charges, index) in processEditableHeader"
          :key="index">
          <template slot="title">
            <Row type="flex" class="grid-collapse grid-bordered p-0">
              <Col :span="columnSpan">
                <div class="cell">
                  <i class="icon-collapse"></i>
                  <span
                    v-if="charges.discrepancyType==='Days'">
                    {{charges.tlabel ? $t(charges.tlabel) : charges.label}}
                    -
                    {{discrepancyCharges[charges.discrepancyColumn] || 0}}
                    {{ charges.discrepancyType}}
                  </span>
                  <span v-else> {{charges.tlabel ? $t(charges.tlabel) : charges.label}} </span>
                  <span class="icon-wrapper f-right">
                    <span class="position-relative">
                      <svgicon
                        v-if="commentsList[charges.column] &&
                        commentsList[charges.column].length"
                        name="icon-comment"
                        class="text-grey-dark2"
                        width="13"
                        height="12"
                      />
                      <i v-if="commentsList[charges.column] &&
                        commentsList[charges.column].length"
                        class="icon-badge">{{commentsList[charges.column].length}}</i>
                    </span>
                    <Tooltip class="item" effect="dark" placement="bottom"
                      v-if="changedCharge[charges.column]
                      && isAttachmentCommentMandatory && (!mandatoryAttachment[charges.column]
                      || !mandatoryComment[charges.column])">
                        <div slot="content" class="tooltipcontent">
                          Comment & Attachment Mandatory
                        </div>
                        <span class="badge badge-bottom">
                          <svgicon name="icon-warning-circle" width="12" height="12" :original="true" />
                        </span>
                    </Tooltip>
                  </span>
                </div>
              </Col>
              <Col v-if="!hideSystemCharges" :span="isShipperChargesFeatureEnabled ? 5 : 5">
                <div class="cell text-right" v-if="!isHideSystemCharge(charges.column)">{{shipperCharges[charges.column]}}</div>
              </Col>
              <Col :span="isShipperChargesFeatureEnabled ? 5 : 5">
                <div v-if="isShipperChargesFeatureEnabled" class="cell text-right">
                  {{ actualTransporterCharges[charges.column] }}
                </div>
                <template v-else>
                  <div v-if="showTransporterDebit && charges.column === 'debit_sub_total'" class="cell text-right">
                    {{ getDebitSubTotal }}</div>
                  <Input
                    v-else
                    :class="`input-blank text-right bg-white ${getTextChargeClass(charges.column)}`"
                    size="mini"
                    type="number"
                    :disabled="charges.readOnly || !editable"
                    v-model.number="transporterCharges[charges.column]"
                    @input="isComputingCharges = true; chargeChanged($event, charges.column, charges.action)"
                  ></Input>
                </template>
              </Col>
              <Col v-if="isShipperChargesFeatureEnabled" :span="4">
                <div class="cell text-right">{{ transporterCharges[charges.column] }}</div>
              </Col>
            </Row>
          </template>
          <div class="collapse-inner">
            <div class="comments-sec"
              v-for="(comment, index) in commentsList[charges.column]" :key="index">
              <h6 class="comments-title">
                <span class="badge bg-orange-light">{{comment.party === 1 ? 'S' : 'T'}}</span>
                <span>{{comment.user_name}}</span>
                <small>{{comment.created_at | moment("DD MMM YY | HH : mm A")}}</small>
              </h6>
              <p v-html="getHighlightedMessage(comment.message)">
              </p>
              <Attachments
                v-if="true"
                :attachments="presentAttachments(comment)"
                :disableUpload="true"
                :showPreview="true"
                :allowDelete="false"
                @preview="preview"
                @removeAttachments="removeAttachments"
              ></Attachments>
            </div>
            <div :id="charges.column"
              class="content-editable mx-m10"
              contenteditable="true"
              badge="true"
              placeholder="Add a comment"
              @keydown.enter="enterToSendComment($event, charges.column)"
              @input="updateHTML($event,charges.column)">
              </div>
              <Attachments
                v-if="true"
                :attachments="tempAttachments[charges.column]"
                :disableUpload="true"
                :showPreview="true"
                :allowDelete="true"
                :sample="true"
                @preview="preview"
                @removeAttachments="removeAttachments"
              ></Attachments>
            <div class="collapse-bottom">
              <div class="btn-group text-right">
                <Upload
                  action
                  list-type="picture-card"
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="addAttachment"
                  class="default-upload upload-plain is-badge">
                  <!-- <Tooltip popper-class="max-width" :open-delay="200"
                    effect="dark" placement="bottom-start"> -->
                    <!-- <div v-if="true"
                      slot="content">Comment Mandatory</div> -->
                    <svgicon
                      name="icon-attachment-sm"
                      class="text-red1 pointer"
                      width="8"
                      height="12"
                      slot="default"
                    />
                  <!-- </Tooltip> -->
                  <div
                    class="el-upload-list__item-slot"
                    slot="file"
                    slot-scope="{ file }">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url"
                      alt=""
                    />
                    <span class="el-upload-list__item-actions">
                      <span class="badge" v-if="attachmentsCountBadge">
                        + {{ attachmentsCountBadge }}
                      </span>
                      <span
                        v-if="!disabled"
                        class="el-upload-list__item-delete"
                        @click="removeAttachment(file)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </Upload>
                <a class="download-file" />
                <Dialog :visible.sync="dialogVisible" :modal="false">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </Dialog>

                <!-- <svgicon name="icon-attachment-sm"
                class="text-red1 pointer" width="8" height="12" /> -->
                <Button
                  type="text"
                  size="mini"
                  class="button-link secondary ml-10"
                    @click="clearMessage(charges.column)"
                  >{{ $t('CANCEL') }}</Button
                >
                <Button :disabled="disableAdd(charges.column)" type="text" size="mini" class="button-link"
                  @click="addComment(charges.column)"
                  >{{ $t('ADD') }}</Button
                >
              </div>
            </div>
            <div v-if="showTransporterDebit && charges.column === 'debit_sub_total'">
              <debit-adjustment
                :transporterDebit="transporterDebitCharge"
                :editDebitAdjust="editable"
                @saveTransporterDebit="saveDebitCharges"
                @cancel="closeDebitAdjust" />
            </div>
          </div>
        </CollapseItem>
      </Collapse>
    </div>
    <Row :gutter="20" class="mx-0 mt-10 text-md">
      <Col :span="columnSpan">
        <strong>{{ $t('TOTAL') }}</strong>
      </Col>
      <Col v-if="!hideSystemCharges" :span="isShipperChargesFeatureEnabled ? 5 : 5" class="text-right"> {{getSystemTotal}} </Col>
      <Col :span="isShipperChargesFeatureEnabled ? 5 : 5" class="text-right"
      :class="getTotalColour"
      >
        <span v-if="isShipperChargesFeatureEnabled">{{ actualTransporterCharges.total_amount }}</span>
        <strong v-else>{{totalAmount}}</strong>
      </Col>
      <Col v-if="isShipperChargesFeatureEnabled" :span="4" class="text-right">
        <strong>{{totalAmount}}</strong>
      </Col>
    </Row>
    <div class="footer-fixed text-right mt-30">
      <Button
        type="primary"
        size="mini"
        v-if="showSave"
        :disabled="!chargesChanged || isComputingCharges"
        @click="saveCharges"
      >{{ $t('SAVE') }}</Button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueSanitize from 'vue-sanitize';
// eslint-disable-next-line import/no-extraneous-dependencies
import Payments from '@common/asset/images/payments.gif';
import Attachments from '@common/components/Attachments';
import DebitAdjustment from '@common/components/DebitAdjustment';
import AttachmentConstants from '@common/constants/AttachmentConstants';
import ChargeMixin from '@common/mixins/ChargeMixin';
import debounce from 'debounce';
import { cloneDeep } from 'lodash';
import { ChargesBy, movementMapLower } from 'pando-constants';
import { InvoiceStatusUtils } from 'status-utils';
import { mapGetters } from 'vuex';


const defaultOptions = {
  allowedTags: ['div'],
  allowedAttributes: {
    // div: ['class', 'contenteditable'],
  },
};
Vue.use(VueSanitize, defaultOptions);

export default {
  name: 'charge-details',
  data() {
    return {
      activeName: null,
      commentsList: {},
      defaultComments: {},
      mandatoryAttachment: {},
      mandatoryComment: {},
      commentIds: {},
      shipperCharges: {},
      transporterCharges: {},
      comment: '',
      changedCharge: {},
      dialogImageUrl: '',
      dialogVisible: false,
      chargesChanged: false,
      discrepancyCharges: {},
      originalTransporterCharges: {},
      debitAdjustValue: 0,
      commentId: null,
      totalAmount: null,
      totalAmountWithoutCustom: null,
      tempAttachments: {},
      validComment: {},
      isSavingCharges: false,
      isComputingCharges: false,
      Payments,
      actualTransporterCharges: {},
    };
  },
  mixins: [ChargeMixin],
  props: {
    indent: {
      type: Object,
    },
    extraKmCharge: {
      default: 0,
    },
    initialExtraKmCharge: {
      type: Number,
      default: 0,
    },
    consigneeDetails: {
      type: Object,
    },
    filteredChargesHeaders: {
      type: Array,
    },
    chargeHeaderLabels: {
      type: Object,
    },
    paymentId: {
      type: Number,
    },
    consigneeDataId: {
      type: Number,
    },
    paymentSettings: {
      type: Object,
    },
    orderType: {
      type: Number,
      default: null,
    },
    rowChargeStatus: null,
    editable: {
      type: Boolean,
      default: false,
    },
    chargeComments: {
      type: Object,
    },
    showTransporterDebit: {
      type: Boolean,
      default: false,
    },
    debitAdjustCharge: {
      type: Number,
      default: 0,
    },
    transporterDebitCharge: {
      type: Object,
    },
    showSave: {
      type: Boolean,
      default: true,
    },
    chargesFixedHeight: {
      type: Boolean,
      default: true,
    },
    orderMovement: null,
    enablePayInDispatch: {
      type: Boolean,
      default: false,
    },
    clientConfig: {
      type: Object,
      default: () => ({}),
    },
    isShipperChargesFeatureEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Attachments,
    DebitAdjustment,
  },
  computed: {
    ...mapGetters({
      depots: 'app/depots',
      currentClient: 'app/currentClient',
      currentUser: 'app/currentUser',
    }),
    columnSpan() {
      if (this.hideSystemCharges) return this.isShipperChargesFeatureEnabled ? 14 : 19;
      return this.isShipperChargesFeatureEnabled ? 10 : 14;
    },
    getSystemTotal() {
      return this.shipperCharges.total_amount;
    },
    hideSystemCharges() {
      return this.paymentSettings && this.paymentSettings.hide_system_charges;
    },
    getTransporterTotal() {
      let totalCharge = 0;
      this.processEditableHeader.forEach((charge) => {
        if (this.transporterCharges[charge.column] !== '') {
          totalCharge += this.transporterCharges[charge.column];
        }
      });
      totalCharge -= this.debitAdjustValue;
      return totalCharge;
    },
    getDebitSubTotal() {
      let total = 0;
      Object.keys(this.transporterDebitCharge)
        .forEach((chargeName) => {
          if (chargeName !== 'transporter_debit_adjust') {
            const value = this.transporterDebitCharge[chargeName] || 0;
            total += Number(value);
          }
        });
      total -= Number(this.debitAdjustValue);
      return Number(total).toFixed(2);
    },
    getTotalColour() {
      if (this.totalAmount > this.getSystemTotal) {
        return 'text-green-dark';
      } else if (this.totalAmount < this.getSystemTotal) {
        return 'text-red1';
      }
      return '';
    },
    processEditableHeader() {
      let result = this.filteredChargesHeaders;
      const isSapEnabled = this.currentClient && this.currentClient.features &&
        this.currentClient.features.includes('sap_charge_integration');
      const invalidChargesInDispatch = ['transit_charge', 'unloading_detention_charge'];
      if (this.paymentSettings && this.paymentSettings.transporter_charge_editable) {
        const settings = this.paymentSettings.transporter_charge_editable[this.orderType];
        // CHECK SETTINGS PRESENT FOR ORDER TYPE(Contract,open,market or use default)
        if (settings) {
          result = [];
          this.filteredChargesHeaders.forEach((header) => {
            const charge = {};
            Object.assign(charge, header);
            const processedCharge = this.canEditCharge(settings, charge);
            // Force all charges editable for SAP clients, including contract_charge (base freight)
            if (isSapEnabled && header.column !== 'contract_charge') {
              processedCharge.readOnly = false;
            }
            result.push(processedCharge);
          });
        }
      }
      if (this.rowChargeStatus) {
        result.forEach((header) => {
          if (!header.readOnly) {
            // eslint-disable-next-line no-param-reassign
            header.readOnly = (this.rowChargeStatus[header.column] !==
          InvoiceStatusUtils.getStatusObjByName('invoice_returned').id);
          }
        });
      }
      if (this.enablePayInDispatch
      && this.indent.status === this.$statusUtil.getStatusId('dispatched')) {
        result.forEach((header) => {
          if (invalidChargesInDispatch.includes(header.column)
          ) {
            // eslint-disable-next-line no-param-reassign
            header.readOnly = true;
          }
        });
      }
      // adding extra KM charges explicitly
      if (this.transporterCharges.extra_km_charge || this.shipperCharges.extra_km_charge) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        result.push({
          id: (Math.max(...result.map(o => o.id)) + 1),
          column: 'extra_km_charge',
          class: 'w150',
          label: 'Extra Km Charges',
          noActionForOpen: true,
          readOnly: true,
        });
      }
      return result;
    },
  },
  methods: {
    checkDoubleExtension(fileParts) {
      if (fileParts.length > 2) {
        const knownExtensions = ['jpeg', 'msg', 'jpg', 'png', 'svg', 'pdf', 'txt', 'doc', 'docx', 'docm', 'xls', 'xlt', 'xlm', 'xlsx', 'xlsm', 'xltx', 'xltm', 'csv', 'eml', 'zip', 'exe', 'com', 'bin', 'dll', 'html', 'htm', 'php', 'pl', 'vbs', 'bat', 'scr', 'pif', 'js'];

        for (let i = 1; i < fileParts.length - 1; i++) {
          if (knownExtensions.includes(fileParts[i].toLowerCase())) {
            return true;
          }
        }
      }
      return false;
    },
    preview(data) {
      this.$emit('preview', data);
    },
    getHighlightedMessage(message) {
      const html = this.$sanitize(message);
      return html;
    },
    isHideSystemCharge(charge) {
      return (
        this.paymentSettings &&
        this.paymentSettings.column_hide_view &&
        this.paymentSettings.column_hide_view[charge]
      );
    },
    getTextChargeClass(charge) {
      if (this.transporterCharges[charge] > this.shipperCharges[charge]) {
        return 'text-green-dark';
      } else if (this.transporterCharges[charge] < this.shipperCharges[charge]) {
        return 'text-red';
      }
      return '';
    },
    enterToSendComment(event, column) {
      this.addComment(column);
    },
    disableAdd(charge) {
      return !(this.validComment[charge] || (this.tempAttachments[charge] && this.tempAttachments[charge].length !== 0));
    },
    // eslint-disable-next-line func-names
    async totalCompute() {
      const resultTotal = await this.calculateTotal();
      let totalAmount = resultTotal.totalWithCustom && resultTotal.totalWithCustom[0].totalAmount;
      const totalWithoutCustom = resultTotal.totalWithoutCustom && resultTotal.totalWithoutCustom[0].totalAmount;
      const movementLevelDecoupleSetting = (this.paymentSettings &&
          this.paymentSettings.decouple_charges[movementMapLower[this.orderMovement]])
          || {};
      const decoupleDebitAdjustment = movementLevelDecoupleSetting.debit_adjustment || false;
      if (!(decoupleDebitAdjustment && this.$hasFeature('wallet_v2'))) {
        totalAmount = Number(totalAmount.toFixed(2)) +
          this.transporterCharges.transporter_debit_adjust;
      }
      this.totalAmount = Number(totalAmount.toFixed(2));
      this.totalAmountWithoutCustom = Number(totalWithoutCustom.toFixed(2));
    },
    findFileExt(file) {
      if (file.name) {
        const fileName = file.name;
        // eslint-disable-next-line no-bitwise
        return fileName.slice(((fileName.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();
      }
      const fileName = file.url;
      // eslint-disable-next-line no-bitwise
      const index1 = ((fileName.lastIndexOf('.') - 1) >>> 0) + 2;
      let index2 = fileName.indexOf('?');
      index2 = index2 === -1 ? fileName.length : index2;
      return fileName.slice(index1, index2).toLowerCase();
    },
    updateHTML(event, chargeName) {
      this.defaultComments[chargeName] = this.$sanitize(event.target.innerHTML);
      this.validComment[chargeName] = (this.defaultComments[chargeName].trim() !== '');
    },
    clearMessage(chargeName) {
      this.tempAttachments[chargeName] = [];
      this.defaultComments[chargeName] = '';
      this.validComment[chargeName] = false;
      document.getElementById(chargeName).innerText = '';
    },
    async addComment(charge) {
      const chargeName = charge;
      const comment = this.defaultComments[chargeName].trim();
      const data = {
        comment,
        chargeName,
      };
      const result = await this.$store.dispatch('paymentsV2/updateChargeComment',
        { id: this.consigneeDataId, data });
      if (result.data) {
        if (comment !== '') {
          this.mandatoryComment[chargeName] += 1;
        }
        this.commentId = result.data.id;
        this.commentIds[chargeName] = result.data.id;
        this.commentsList[chargeName].push({
          commentId: result.data.id,
          id: result.data.id,
          message: result.data.message,
          user_name: result.data.user_name,
          created_at: result.data.created_at,
        });
        this.tempAttachments[chargeName].forEach((attachment) => {
          this.storeAttachment(attachment.file, this.commentId);
        });
        this.clearMessage(chargeName);
        await this.isChargesModified();
      } else if (result.error) {
        this.$errorMessage({ message: result.error });
      }
    },
    addAttachment(file, fileList) {
      const isSizeExceed = file.size / 1024 / 1024 < AttachmentConstants.maxMbSize;
      const fileExt = this.findFileExt(file);
      let isFileFormat = AttachmentConstants.images.includes(fileExt) ||
        AttachmentConstants.pdf.includes(fileExt) ||
        AttachmentConstants.excel.includes(fileExt);

      // Check for double extensions
      const fileName = file.name;
      const fileParts = fileName.split('.');
      const hasDoubleExtension = this.checkDoubleExtension(fileParts);

      if (this.disableBoxOption) {
        isFileFormat = AttachmentConstants.images.includes(fileExt);
      }
      if (!isSizeExceed) {
        this.$errorMessage({ message: this.$getErr('FILE_SIZE_EXCEED') });
        fileList.pop();
      } else if (!isFileFormat) {
        this.$errorMessage({ message: this.$getErr('INVALID_FORMAT') });
        fileList.pop();
      } else if (hasDoubleExtension) {
        this.$errorMessage({ message: 'File with multiple extensions not allowed' });
        fileList.pop();
      } else {
        const chargeName = this.processEditableHeader[this.activeName].column;
        this.tempAttachments[chargeName].push({
          url: file.url,
          name: file.name,
          file,
        });
      }
    },
    async storeAttachment(file, commentId) {
      const formData = new FormData();
      let chargeName = null;
      chargeName = this.processEditableHeader[this.activeName].column;
      formData.append('attachment', file.raw);
      const result = await this.$store.dispatch('paymentsV2/updateCommentAttachment',
        { commentId, formData });
      if (result && result.error) {
        this.$errorMessage({ message: result.error || this.$getErr('UPLOAD_FAILS') });
      } else if (result.data) {
        this.mandatoryAttachment[chargeName] += 1;
        const comment = this.commentsList[chargeName][this.commentsList[chargeName].length - 1];
        if (comment.attachments) {
          comment.attachments.push(result.data);
        } else {
          comment.attachments = [result.data];
        }
        this.commentsList[chargeName].pop();
        this.commentsList[chargeName].push(comment);
        await this.isChargesModified();
      }
    },
    presentAttachments(comment) {
      const attachments = comment.attachments || [];
      return attachments.map(attachment => ({
        id: attachment.id,
        url: attachment.metadata && attachment.metadata.location,
      }));
    },
    async removeAttachments(file) {
      const chargeName = this.processEditableHeader[this.activeName].column;
      this.tempAttachments[chargeName] = this.tempAttachments[chargeName].filter(
        attachment => attachment.uid !== file.uid);
    },
    async isChargesModified() {
      const changedCharges = Object.keys(this.changedCharge);
      this.chargesChanged = (changedCharges.length > 0);
      changedCharges.forEach((charge) => {
        if (this.changedCharge[charge] === '' || (this.isAttachmentCommentMandatory && (!this.mandatoryAttachment[charge] || !this.mandatoryComment[charge]))) {
          this.chargesChanged = false;
        }
      });
      await this.totalCompute();
      const data = this.getUpdatedConsigneeData();
      this.$emit('updateChange', data);
    },
    // eslint-disable-next-line func-names
    chargeChanged: debounce(async function (value, chargeName, action) {
      if (!isNaN(parseInt(value, 10))) {
        let dataInput = Number(value);
        const decimalValues =
          (value.toString().split('.')[1] &&
            value.toString().split('.')[1].length) || 0;
        if (decimalValues > 2) {
          dataInput = Number(dataInput.toFixed(2));
        }
        if (action === 'incrementOnly' && dataInput < this.shipperCharges[chargeName]) {
          this.$errorMessage({ message: this.$getErr('DECREMENT_BLOCKING') });
          this.transporterCharges[chargeName] = this.originalTransporterCharges[chargeName];
        } else if (action === 'decrementOnly' && dataInput > this.shipperCharges[chargeName]) {
          this.$errorMessage({ message: this.$getErr('INCREMENT_BLOCKING') });
          this.transporterCharges[chargeName] = this.originalTransporterCharges[chargeName];
        } else {
          this.changedCharge[chargeName] = parseInt(dataInput, 10);
          this.transporterCharges[chargeName] = dataInput;
          await this.isChargesModified();
        }
      } else {
        this.changedCharge[chargeName] = '';
        this.transporterCharges[chargeName] = this.originalTransporterCharges[chargeName];
        this.$errorMessage({ message: 'Please Type a valid charge!' });
        await this.isChargesModified();
      }
      this.isComputingCharges = false;
    }, 1000),
    async saveDebitCharges(params) {
      const oldDebitAdjustValue = this.debitAdjustValue;
      this.debitAdjustValue = params.debitAdjustment.toString();
      const data = {
        client_id: this.currentClient && this.currentClient.id,
        order_no: this.indent.order_reference,
        amount: params.debitAdjustment,
        payment_id: this.indent.id,
        consignee_id: this.consigneeDataId,
      };
      const result = await this.$store.dispatch('paymentsV2/saveTransporterDebit', data);
      if (result && result.data) {
        this.changedCharge = {
          ...this.changedCharge,
          transporter_debit_adjust: Number(params.debitAdjustment),
          debitSubtotal: this.getDebitSubTotal,
        };
        const movementLevelDecoupleSetting = (this.paymentSettings &&
            this.paymentSettings.decouple_charges[movementMapLower[this.orderMovement]])
            || {};
        const decoupleDebitAdjustment = movementLevelDecoupleSetting.debit_adjustment || false;
        if (!(decoupleDebitAdjustment && this.$hasFeature('wallet_v2'))) {
          this.totalAmount = (this.totalAmount - Number(oldDebitAdjustValue))
            + Number(this.debitAdjustValue);
        }
        const updatedData = {
          id: this.paymentId,
          charges: { ...this.changedCharge, total_amount: this.totalAmount },
          consigneeId: this.consigneeDataId,
        };
        this.$emit('save', updatedData, false);
        this.closeDebitAdjust();
        return true;
      }
      this.$errorMessage({ message: this.$getErr('DEBIT_ADJUSTMENT_FAILED') });
      return false;
    },
    getUpdatedConsigneeData() {
      const chargeValues = {};
      const editableCustomCharges = [];
      Object.assign(chargeValues, this.transporterCharges);
      // chargeValues.total_amount = this.getTransporterTotal;
      chargeValues.total_amount = this.totalAmount - parseInt(this.extraKmCharge, 10);
      chargeValues.charges_total_amount = this.totalAmountWithoutCustom - parseInt(this.extraKmCharge, 10); // total without custom charges
      chargeValues.charges_by = ChargesBy.TRANSPORTER;
      delete chargeValues.extra_km_charge;
      delete chargeValues.transporter_debit_adjust;
      delete chargeValues.destination_location_id;
      delete chargeValues.payment_id;
      delete chargeValues.created_at;
      delete chargeValues.updated_at;
      delete chargeValues.debitSubtotal;
      delete chargeValues.invoice_id;
      delete chargeValues.transporter_debit;
      if (!(this.changedCharge && this.changedCharge.fixed_charge)) {
        delete chargeValues.fixed_charge;
      }
      // Check if SAP is enabled
      const isSapEnabled = this.currentClient && this.currentClient.features &&
        this.currentClient.features.includes('sap_charge_integration');

      if (isSapEnabled) {
        // SAP flow: send all custom charges (skip clientConfig check)
        Object.keys(chargeValues).forEach((charge) => {
          if (chargeValues[charge] === null) delete chargeValues[charge];
        });
      } else {
        // Standard flow: only include editable custom charges from config
        const validCustomCharges = ([...(this.clientConfig.rate_matrix_custom_charges || []), ...(this.clientConfig.allowable_destination_charge_codes || []), ...(this.clientConfig.allowable_source_charge_codes || [])]);
        for (let i = 0; i < validCustomCharges.length; i += 1) {
          if (validCustomCharges[i].is_editable) {
            editableCustomCharges.push(validCustomCharges[i].name);
          }
        }
        Object.keys(chargeValues).forEach((charge) => {
          if (chargeValues[charge] === null) delete chargeValues[charge];
          const customCharge = charge.replace('custom_', '');
          if (charge.startsWith('custom_') && !editableCustomCharges.includes(customCharge)) delete chargeValues[charge];
        });
      }
      return {
        id: this.consigneeDataId,
        charges: chargeValues,
      };
    },
    async saveCharges() {
      this.isSavingCharges = true;
      const payload = {
        id: this.paymentId,
        consignee_data: [this.getUpdatedConsigneeData()],
        comments: [],
        attachments: [],
      };
      const response = await this.$store.dispatch('paymentsV2/updatePaymentCharge', payload);
      if (response && response.error) {
        this.$errorMessage({ message: response.error });
      } else {
        this.$successMessage({ message: this.$getSuccess('UPDATE_SUCCESS') });
        this.chargesChanged = false;
        this.commentId = null;
        const updatedData = {
          id: this.paymentId,
          charges: { ...this.changedCharge, total_amount: this.totalAmount },
          consigneeId: this.consigneeDataId,
        };
        this.$emit('save', updatedData);
      }
      this.isSavingCharges = false;
    },
    async closeDebitAdjust() {
      this.activeName = null;
    },
    setDefaults() {
      const defaultComments = {};
      const mandatoryAttachment = {};
      const mandatoryComment = {};
      const commentIds = {};
      const tempAttachments = {};
      const validComment = {};
      this.isAttachmentCommentMandatory =
        this.paymentSettings.mandate_comment_attachment || false;
      const commentsList = this.processEditableHeader.reduce((acc, charge) => {
        acc[charge.column] = this.chargeComments[charge.column] || [];
        defaultComments[charge.column] = '';
        mandatoryAttachment[charge.column] = 0;
        mandatoryComment[charge.column] = 0;
        commentIds[charge.column] = null;
        tempAttachments[charge.column] = [];
        validComment[charge.column] = false;
        return acc;
      }, {});
      this.commentsList = commentsList;
      this.defaultComments = defaultComments;
      this.mandatoryAttachment = mandatoryAttachment;
      this.mandatoryComment = mandatoryComment;
      this.commentIds = commentIds;
      this.tempAttachments = tempAttachments;
      this.validComment = validComment;
    },
    resetValues() {
      this.comment = '';
      this.changedCharge = {};
      this.activeName = null;
      this.dialogImageUrl = '';
      this.dialogVisible = false;
      this.chargesChanged = false;
      const consigneeData = this.consigneeDetails;
      this.discrepancyCharges = (consigneeData.discrepancyCharges) ?
        cloneDeep((consigneeData.discrepancyCharges[0])) : {};
      delete this.discrepancyCharges.destination_location_id;
      delete this.discrepancyCharges.id;
      delete this.discrepancyCharges.updated_at;
      delete this.discrepancyCharges.created_at;

      this.transporterCharges = cloneDeep(consigneeData.charges
        .find(charge => charge.charges_by === ChargesBy.TRANSPORTER));
      this.transporterCharges.extra_km_charge = Number(this.transporterCharges.extra_km_charge) || 0;
      this.originalTransporterCharges = cloneDeep(consigneeData.charges
        .find(charge => charge.charges_by === ChargesBy.TRANSPORTER));
      const hideSystemCharges = this.paymentSettings && this.paymentSettings.hide_system_charges;
      this.shipperCharges = hideSystemCharges ? [] : cloneDeep(consigneeData.charges
        .find(charge => charge.charges_by === ChargesBy.SHIPPER));
      this.debitAdjustValue = this.debitAdjustCharge;
      this.shipperCharges.extra_km_charge = this.shipperCharges.extra_km_charge
        || Number(this.initialExtraKmCharge);
      const total = (this.shipperCharges.total_amount + this.initialExtraKmCharge).toFixed(2);
      this.shipperCharges.total_amount = Number(total);
      this.shipperCharges.debit_sub_total = this.shipperCharges.debitSubtotal;
      // PAN-40066: populate ACTUAL_TRANSPORTER charges when feature enabled
      if (this.isShipperChargesFeatureEnabled) {
        this.actualTransporterCharges = cloneDeep(
          consigneeData.charges.find(charge => charge.charges_by === ChargesBy.ACTUAL_TRANSPORTER)
        ) || {};
      }
      this.setDefaults();
    },
  },
  mounted() {
    this.resetValues();
    this.totalCompute();
  },
};
</script>
